import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';


import BrowseBookPage from '../../../subsreens/gcstudent/browsebookpage/BrowseBookPage';

const BrowseBooks = () => {
    return(
        <StudentDashboardLayout>
            <BrowseBookPage></BrowseBookPage>
        </StudentDashboardLayout>
    )
}

export default  BrowseBooks;